// permission-plugin.ts
import { useUserStore } from "@stores/userStore";

export default {
    install(app) {
        const store = useUserStore();

        app.config.globalProperties.$can = (perm) => {
            return store.can(perm);
        };
    },
};
